import { render, staticRenderFns } from "./VenderProfile.vue?vue&type=template&id=335638a8&"
import script from "./VenderProfile.vue?vue&type=script&lang=js&"
export * from "./VenderProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports